import type { AccordionPanelPassThroughOptions } from "primevue/accordionpanel";

export const accordionpanel: AccordionPanelPassThroughOptions = {
  root: "flex flex-col gap-3 items-start"
};
